class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.submenus = this.mainDetailsToggle.querySelectorAll('.header-dropdown')
    this.headerLinks = document.querySelector('.header-menu').querySelectorAll('.text-link:not(.text-link-submenu)');

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    if (this.classList.contains('header-menu-dropdown') && this.submenus) {
      this.mainDetailsToggle.addEventListener('mouseenter', this.open.bind(this));
      this.submenus.forEach(menu => menu.addEventListener('mouseleave', this.close.bind(this)));
      if (this.headerLinks) {
        this.headerLinks.forEach(link => link.addEventListener('mouseover', this.close.bind(this)));
      }
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }

  open() {
    document.querySelector('.header').querySelectorAll('details-disclosure').forEach(detailsDisclosure => {
      if (detailsDisclosure == this) {
        return;
      }
      detailsDisclosure.close();
    })
    this.mainDetailsToggle.setAttribute('open', '');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
